import { useEntity } from 'hooks/useEntity'
import Alert from "components/ui/Alert/Alert";
import { useTitle } from "hooks/useTitle";
import TopBanner from "layout/TopBanner/TopBanner";
import ImageHero from "features/marketplace/assets/images/hero.svg";
import ViewContextProvider from "features/view/context/ViewContext";
import { useLocationAwareSortOptions } from "hooks/useLocationAwareSortOptions";
import MarketplaceCreateButton from "features/marketplace/components/MarketplaceCreateButton";
import ViewMarketplace from "features/marketplace/components/ViewMarketplace";

function Marketplace({ title }) {
  const { entity, isLoading, error } = useEntity('/vraag-en-aanbod', 'page');
  const sortOptions = useLocationAwareSortOptions();

  useTitle(title);

  if (error) {
    return <Alert/>;
  }

  return (
    <>
      <TopBanner title={ entity?.title?.value || '' }
                 intro={ entity?.field_intro?.value || '' }
                 image={ ImageHero }
                 sortOptions={ sortOptions }>

        { !isLoading && <MarketplaceCreateButton categoryId={ entity.field_bulletin_category.id }/> }
      </TopBanner>
      <div className="wrapper--fluid grid">
        <div className="content content--background">
          <div className="grid">
            { !isLoading &&
              <ViewContextProvider name={ `bulletin/list/${ entity.field_bulletin_category.id }` }>
                <ViewMarketplace/>
              </ViewContextProvider>
            }
          </div>
        </div>
      </div>
    </>
  )
}

export default Marketplace;
